import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { OpzioniFiltroCompilabile } from './opzioni-filtro-compilabile/opzioni-filtro-compilabile.component';
import * as _ from 'lodash';
import Fuse from 'fuse.js';
import { SuperCampo } from '../../model/superCampo';
import { AppLocaleService, AppLocaleUtils } from '@alfercom/common-utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: ".filtro-compilabile",
  templateUrl: "./filtro-compilabile.html"
})
export class FiltroCompilabile {

  @Input('campo') set campo(campo: SuperCampo) {
    this.initFormGroup(campo);
  }

  campoMapped: FiltroCompilabileType = {
    id: null,
    label: null,
    labelOperatore: null,
    type: null,
    items: null,
    formGroup: null,
    controlName: null,
    controlType: null,
    showMostraAltri: false,
    prevValue: null,
    infoFiltriSelezioneMultipla: null,
    suggerimenti: null
  }

  selectLoadIndex: number = 0;

  @Output('modificaFiltroOUTPUT') modificaFiltroEmitter: EventEmitter<{ id: string, value: any, forceDisattivazione: boolean }> = new EventEmitter();

  //Utils Copiato da @alfercom/dynamic-form-generator
  private defaultDateTimePickerFormat = 'dd/MM/yyyy HH:mm'; //default IT
  private defaultDatePickerFormat = 'dd/MM/yyyy'; //default IT

  constructor(
    private fb: FormBuilder,
    private modalController: NzModalService,
    private appLocaleService: AppLocaleService,
    private translateService: TranslateService
  ) {
    this.initI18nConfig();
  }

  /**
  * Inizializzazione della configurazione della lingua
  */
  initI18nConfig() {
    if (this.appLocaleService.getCurrentLocale()) {
      this.defaultDatePickerFormat = AppLocaleUtils.dateFormatAngular(this.appLocaleService.getCurrentLocale());
      this.defaultDateTimePickerFormat = AppLocaleUtils.dateTimeFormatAngular(this.appLocaleService.getCurrentLocale());
    }
  }

  initFormGroup(_campo: SuperCampo) {
    const campo = _.cloneDeep(_campo);
    const filtroControlName = campo.id + "_" + campo.operator.id;
    const _value = campo.value == 'null' ? null : campo.value;
    this.campoMapped.formGroup = new FormGroup({});
    // console.log("valore campo", campo.value, "filtroControlName", filtroControlName, "campo.controlType", campo.controlType);
    this.campoMapped.formGroup.addControl(filtroControlName, new FormControl(_value));
    this.campoMapped.prevValue = _value;
    this.campoMapped.id = campo.id;
    this.campoMapped.label = campo.label;
    this.campoMapped.labelOperatore = campo.operator.text;
    this.campoMapped.type = campo.type;
    this.campoMapped.items = campo.options;
    this.campoMapped.controlName = filtroControlName;
    this.campoMapped.controlType = campo.controlType;
    //Se sono delle selezioni
    if (this.campoMapped.controlType == "selezione-multipla" || this.campoMapped.controlType == "selezione-singola") {
      if (this.campoMapped.controlType == 'selezione-multipla') {
        let items = [...this.campoMapped.items];
        this.campoMapped.items = items.map(el => {
          let isChecked = false;
          if (campo.extra && campo.extra.filtriMapped) {//contiene tutte le info per matchare la singola checkbox a un filtro
            this.campoMapped.infoFiltriSelezioneMultipla = campo.extra.filtriMapped;
            const filtriMapped = campo.extra.filtriMapped;
            const optMap = filtriMapped.find(_el => _el.idOption == el.id);
            if (optMap) {
              isChecked = optMap.isChecked;
            }
          }
          return {
            label: el.text,
            value: el.id,
            disabled: false,
            checked: isChecked
          }
        });
      } else {
        const opzioneDisattivaIndex = this.campoMapped.items.findIndex(el => el.id == 'disattiva');
        if (opzioneDisattivaIndex !== -1) {//se c'è rimuovo sempre
          this.campoMapped.items.splice(opzioneDisattivaIndex, 1);
        }
        this.campoMapped.items.unshift({//metto in testa
          id: 'disattiva',
          text: 'FEPB_CRUD_FILTERDRAWER_SELECTALLOPTION'
        })
        if (this.campoMapped.formGroup.get(filtroControlName).value == null || this.campoMapped.formGroup.get(filtroControlName).value == undefined)
          this.campoMapped.formGroup.get(filtroControlName).setValue('disattiva');
      }
      this.itemsSelectable();
    } else {//per i suggerimenti
      if (campo.extra && campo.extra.suggerimenti)
        this.campoMapped.suggerimenti = campo.extra.suggerimenti;
    }
    // console.log("campoMapped", this.campoMapped)
  }


  modificheHandler() {
    if (this.campoMapped.controlType == 'selezione-multipla') {
      this.itemsSelectableToItems();
      for (let item of this.campoMapped.items) {
        const infoFiltro = this.campoMapped.infoFiltriSelezioneMultipla.find(el => el.idOption == item.value);
        if (infoFiltro) {
          // console.log(infoFiltro.isChecked, item.checked);
          if (infoFiltro.isChecked !== item.checked) {
            if (item.checked) {
              this.emitModifica(infoFiltro.idFiltro, item.value); //lo attivo
            } else {
              this.emitModifica(infoFiltro.idFiltro, item.value, true); //lo disattivo
            }
          }
        }//else non può essere
      }
    } else {
      let actualValue = this.campoMapped.formGroup.get(this.campoMapped.controlName).value;
      if (actualValue !== this.campoMapped.prevValue) {//TODO da migliorare in base al tipo
        if (actualValue == "" || actualValue == null || actualValue == 'disattiva') {
          this.emitModifica(null, null, true);
        } else {
          this.emitModifica(null, actualValue);
        }
        //se è selezione singola e se non lo è amen - resetto l'elenco e la ricerca. Così all'apertura riparte la paginazione
        this.campoMapped.searchedValue = null;
        this.selectLoadIndex = 0;
      }
    }
  }

  resetFormGroup() {
    this.campoMapped.formGroup.reset();
    this.emitModifica(null, null, true);
  }

  emitModifica(id: string = null, _value: any = null, disattivaFiltro: boolean = false) {
    const value = _value;
    let forceDisattivazione: boolean = false;
    if (disattivaFiltro) {
      forceDisattivazione = true;
    }
    this.modificaFiltroEmitter.emit({
      id: id ? id : "" + this.campoMapped.id,
      value: value,
      forceDisattivazione: forceDisattivazione
    });
  }

  /**
   * Se gli elementi sono troppi per i checkbox e i radio button creo un'anteprima
   * @param elements 
   */
  itemsSelectable(elements: any[] = null) {
    if (elements) {
      this.campoMapped.items = [...elements];
    }
    if (this.campoMapped.items && Array.isArray(this.campoMapped.items) && this.campoMapped.items.length > 10) {
      if (this.campoMapped.controlType == 'selezione-multipla') {
        this.campoMapped.itemsSelectable = [...this.campoMapped.items].slice(0, 9);
        this.campoMapped.showMostraAltri = true;
      } else if (this.campoMapped.controlType == 'selezione-singola') {
        this.campoMapped.itemsSelectable = [...this.campoMapped.items];
        this.loadElements();
        this.campoMapped.showAutoComplete = true;
      }
    } else {
      this.campoMapped.itemsSelectable = [...this.campoMapped.items];
    }
  }

  itemsSelectableToItems() {//solo per selezione multipla
    for (let itemsS of this.campoMapped.itemsSelectable) {
      const item = this.campoMapped.items.find(el => el.value == itemsS.value);
      if (item) {
        item.checked = itemsS.checked;
      }
    }
  }

  /**
   * Vale solo per selezione-multipla e selezione-singola, apre un modale con tutte le opzioni possibili
   * Apre un modalino con tutte le opzioni 
   */
  visualizzaOpzioni() {
    if (this.campoMapped.controlType == 'selezione-multipla')
      this.itemsSelectableToItems();

    let campoIN: any = _.cloneDeep(this.campoMapped);
    campoIN.value = this.campoMapped.formGroup.get(this.campoMapped.controlName).value;
    const translatedTitle = this.translateService.instant('FEPB_CRUD_FILTERDRAWER_SELECT_SHOWALLOPTIONS_MODALTITLE');

    const modalRef = this.modalController.create({
      nzTitle: translatedTitle + this.campoMapped.label,
      nzClassName: "w-50",
      nzContent: OpzioniFiltroCompilabile,
      nzComponentParams: {
        campoFiltroIN: campoIN
      },
    });
    modalRef.afterClose.subscribe(res => {
      if (res) {
        if (this.campoMapped.controlType == 'selezione-multipla') {
          this.itemsSelectable(res.value);
        } else {
          this.campoMapped.formGroup.get(this.campoMapped.controlName).setValue(res.value);
        }
        this.modificheHandler();
      }
    })
  }

  setFormGroupValue(value: any) {
    this.campoMapped.formGroup.get(this.campoMapped.controlName).setValue(value);
  }

  searchAutocomplete(label: string = null) {
    // console.log("searchAutocomplete")
    let results: any[] = [];
    const items = [...this.campoMapped.itemsSelectable];
    let itemsFiltered: any = [];
    if (label) {
      var options = {
        threshold: 0.1,
        distance: 1000,
        location: 10,
        keys: ['text'],
      };
      var fuse = new Fuse(items, options);
      try {
        if (label.length > 2) {
          results = fuse.search(label) as any[];
          itemsFiltered = _.cloneDeep(results.map((el) => el.item));
        } else {
          itemsFiltered = [...items];
        }
      } catch (e) {
        results = [];
      }
    } else { }
    this.campoMapped.searchedValue = label;
    this.selectLoadIndex = 0;//setto per la "paginazione"
    this.loadElements(itemsFiltered);
  }

  loadElements(itemsSearched: { id: any, text: string }[] = []) {
    // console.log("loadElements", itemsSearched)
    let itemsFiltered = [];
    if (!this.campoMapped.searchedValue) {//se non "arrivo" dalla ricerca vado avanti con il caricamento a blocchi di 30
      itemsFiltered = _.cloneDeep(this.campoMapped.itemsFiltered || []);
      const itemsToAdd = this.campoMapped.itemsSelectable.slice(this.selectLoadIndex, this.selectLoadIndex + 30);
      if (itemsToAdd) {
        itemsFiltered.push(...itemsToAdd);
        this.selectLoadIndex = this.selectLoadIndex + 30;
      }
    } else {//arrivo dalla ricerca e forse ho degli items da mostrare
      itemsFiltered = _.cloneDeep(itemsSearched);
      this.selectLoadIndex = 0;
    }
    // console.log(this.selectLoadIndex, itemsFiltered);
    const actualValue = this.campoMapped.formGroup.get(this.campoMapped.controlName).value;
    const actualItem = this.campoMapped.itemsSelectable.find(el => el.id == actualValue);
    if (actualValue && actualItem) {
      itemsFiltered.unshift(actualItem);//aggiungo sempre il valore corrente come primo
    }
    this.campoMapped.itemsFiltered = _.cloneDeep(_.uniqBy(itemsFiltered, 'id'));//rimuovo il doppione del valore corrente
  }
}

export type FiltroCompilabileType = {
  id: number,
  label: string,
  labelOperatore: string,
  type: string,
  items?: any[],
  itemsSelectable?: any | {
    label: string, value: string, disabled: boolean, checked: boolean
  }[],//per checkbox group di ngZorro,
  itemsFiltered?: { id: any, text: string }[];
  searchedValue?: string;
  formGroup: FormGroup,
  controlName: string,
  controlType: string,
  showMostraAltri: boolean,
  showAutoComplete?: boolean,
  prevValue?: any,
  infoFiltriSelezioneMultipla?: any,
  suggerimenti?: { id: number, text: string, value: any }[];
}